/** @jsx jsx */
import { jsx } from '@emotion/core';
import { FC, ReactNode } from 'react';
import { Flex, Text, Box, Link, Image } from 'rebass';
import MainContainer from '../container/container';
import CookieConsent from "react-cookie-consent";

interface Props {
  className?: string;
  id?: string;
  children?: ReactNode;

  css?: any;
}

const Footer: FC<Props & JSX.IntrinsicElements['footer']> = ({
  className = '',
  id = '',
  children,
  ...rest
}) => {
  return (
    <Box backgroundColor="background" color="primary" py={[2, 4]}>
      <Flex>
      <CookieConsent
        location="bottom"
        buttonText="Got it"
        cookieName="acceptedPrivacyPolicy"
        style={{ background: "#0E131F", maxWidth: "440px", padding: "20px 10px" }}
        buttonStyle={{ 
          backgroundColor: "#a43894",
          color: "#fafaff",
          fontSize: "1em", 
          borderRadius: 5,
          padding: '8px 30px',
          border: '2px solid',
          borderColor: '#a43894',
          fontWeight: 'heading',
          textDecoration: 'none',
          '&:hover': {
            opacity: 0.8,
            cursor: 'pointer'
          } 
        }}
        expires={182}
      >
        This website uses cookies to ensure you get the best experience on our website. 
        <Link href="/privacy-policy/" pl={2} color="primary" data-gtm-link-track={`website-footer--privacy-policy`}>Learn more</Link>
      </CookieConsent>
      </Flex>
      <Flex as="footer">
        <MainContainer py={4} justifyContent="space-between">
          <Flex
            flex={['0 1 100%', '0 1 100%', '0 1 100%']}
            maxWidth={['100%', '100%', '100%']}
            pt={2}
            px={0}
            flexWrap="wrap"
          >
            <Flex
              flex={['0 1 50%', '0 1 50%', '0 1 25%']}
              maxWidth={['50%', '50%', '25%']}
              flexWrap="wrap"
              height="fit-content"
            >
              <Link variant="footerLink" href="/about/"  data-gtm-link-track={`website-footer--about`}>
                About
              </Link>
              <Link variant="footerLink" href="/curriculum/" data-gtm-link-track={`website-footer--curriculum`}>
                Curriculum
              </Link>
              <Link variant="footerLink" href="/contact-us/" data-gtm-link-track={`website-footer--contact-us`}>
                Contact Us
              </Link>
            </Flex>
            <Flex
              flex={['0 1 50%', '0 1 50%', '0 1 25%']}
              maxWidth={['50%', '50%', '25%']}
              flexWrap="wrap"
              height="fit-content"
            >
              <Link variant="footerLink" href="/donate/"  data-gtm-link-track={`website-footer--donate`}>
                Donate
              </Link>
              <Link variant="footerLink" href="/news/" data-gtm-link-track={`website-footer--blog`}>
                News
              </Link>
              <Link variant="footerLink" href="/blog/" data-gtm-link-track={`website-footer--blog`}>
                Blog
              </Link>
              <Link variant="footerLink" href="/professional-development/"  data-gtm-link-track={`website-footer--professional-development`}>
                PD
              </Link>
            </Flex>
            <Flex
              flex={['0 1 50%', '0 1 50%', '0 1 20%']}
              maxWidth={['50%', '50%', '20%']}
              flexWrap="wrap"
              pt={[3, 3, 0]}
              height="fit-content"
            >
              <Link variant="footerLink" href="/contact-us/" data-gtm-link-track={`website-footer--contact-us`}>
                Say Hello
              </Link>
              <Link variant="footerText" href="mailto:info@bootuppd.org" mb={1} data-gtm-link-track={`website-footer--email`}>
                info@bootuppd.org
              </Link>
              <Link variant="footerText" href="tel:+14142125037" data-gtm-link-track={`website-footer--phone`}>
                (414) 212-5037
              </Link>
            </Flex>
          </Flex>
        </MainContainer>
      </Flex>
      <Flex color="purple" backgroundColor="background">
        <MainContainer
          py={2}
          textAlign="center"
          alignItems="center"
          sx={{ borderTop: '1px solid #FFF', borderColor: 'purple' }}
        >
          <Text variant="footerLegal" fontSize={0} pr="2em" pb={3}>
            <span role="img" aria-label="Copyright">
              &copy;
            </span>
            2020 - {new Date().getFullYear()} BootUp PD, Inc. All rights reserved. BootUp is an IRS Section 501(c)(3) organization.
          </Text>
          <Text variant="footerLegal" fontSize={0} textAlign="left">
            Unless otherwise indicated, all materials on these pages are copyrighted by BootUp PD, Inc. No part of these pages, either text or image may be used for any purpose other than personal use. Therefore, reproduction, modification, storage in a retrieval system or retransmission, in any form or by any means, electronic, mechanical or otherwise, for reasons other than personal use, is strictly prohibited without prior written permission.
          </Text>
          <Flex justifyContent="space-between" width="100%" pt={4} alignItems="baseline">
            <Link href="https://www.contentful.com/" rel="nofollow" target="_blank" data-gtm-link-track={`website-footer--contentful`}><img src="https://images.ctfassets.net/fo9twyrwpveg/44baP9Gtm8qE2Umm8CQwQk/c43325463d1cb5db2ef97fca0788ea55/PoweredByContentful_LightBackground.svg" className="contentful-svg" alt="Powered by Contentful" /></Link>
            <Text ml="auto">
              <Link variant="footerLegal" href="/terms-of-service/" data-gtm-link-track={`website-footer--terms-of-service`}>
                Terms of Service
              </Link>
              <Link variant="footerLegal" href="/cookie-policy/" data-gtm-link-track={`website-footer--cookie-policy`}>
                Cookie Policy
              </Link>
              <Link variant="footerLegal" href="/privacy-policy/" mr="0" data-gtm-link-track={`website-footer--privacy-policy`}>
                Privacy Policy
              </Link>
            </Text>
          </Flex>
        </MainContainer>
      </Flex>
    </Box>
  );
};

export default Footer;
